// Plan subscription tiers
export enum Plan {
  STARTER = "starter",
  PRO = "pro",
  AGENCY = "agency",
}

// Review fetch frequency options
export enum FetchFrequency {
  EVERY_4_HOURS = "every_4_hours",
  EVERY_12_HOURS = "every_12_hours",
  DAILY = "daily",
  MANUAL = "manual",
}

// Step 1: Account credentials
export interface Step1Data {
  full_name: string;
  email: string;
  password: string;
  confirmPassword: string;
}

// Step 2: Business profile and preferences
export interface Step2Data {
  business_name: string;
  industry: string;
  brand_voice: string;
  website_url?: string;
  plan: Plan;
  fetch_frequency: FetchFrequency;
}

// Step 3: First location setup
export interface Step3Data {
  location_name: string;
  location_address: string;
  notification_email: string;
  // Fernet-encrypted OAuth credential blob returned by the Google OAuth callback.
  // Sent to the backend at registration; never stored in plain text on the client.
  google_credentials?: string;
  // Judge.me credentials — only shown/required for pro/agency plans.
  judge_me_api_token?: string;
  judge_me_shop_domain?: string;
  phone_number?: string;
}

// Combined form state across all steps
export interface RegistrationFormState extends Step1Data, Step2Data, Step3Data {}

// Backend response after successful registration
export interface RegistrationResponse {
  customer_id: string;
  api_key: string;
  jwt_token: string;
  location_id: string;
  email_sent: boolean;
  onboarding_completed: boolean;
  email_verified: boolean;
}

// Backend response after login
export interface LoginResponse {
  jwt_token: string;
  customer_id: string;
  email_verified: boolean;
}

// Backend response after email verification
export interface VerifyEmailResponse {
  verified: boolean;
  onboarding_completed: boolean;
}
